import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.backgrounds.main,
    },
    form: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
    },
    contentWrapper: {
        height: "400px",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
    divider: {
        width: "100%",
    },
    footer: {
        justifyContent: "flex-end",
        display: "flex",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
        gap: theme.spacing(4),
    },
    footerWithThirdButton: {
        display: "flex",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
        gap: theme.spacing(4),
        justifyContent: "space-between",
    },
    footerMainActions: {
        display: "flex",
        gap: theme.spacing(4),
    },
}));
